import { useCallback, useState } from "react";
import { ModalState } from "../type";

export function useModalState() {
  const [modalState, setModalState] = useState<ModalState>({
    open: false,
    content: "",
  });

  const handleModalClose = useCallback(() => {
    setModalState({
      open: false,
      content: "",
    });
  }, [setModalState]);

  const handleModalOpen = useCallback(
    (content: string) => {
      setModalState({
        open: true,
        content: content,
      });
    },
    [setModalState]
  );

  return { modalState, handleModalOpen, handleModalClose };
}
